module.exports = [
  "Grundstücke",
  "Baugrund für Ein- / Zweifamilienhäuser",
  "Baugrund für Freizeit",
  "Baugrund für Gewerbe",
  "Grundstück Land und Forstwirtschaft",
  "Grundstück",
];



// WEBPACK FOOTER //
// ./src/data/plot.js